document.querySelectorAll('.group-tabs-wrapper').forEach(wrapper => {

  const tabs = wrapper.querySelectorAll('.group-tab');
  const panels = wrapper.querySelectorAll('.group-panel');
  const seeAllBtn = wrapper.querySelector('.group-see-all'); // ✅ use class

  function updateButton(panel) {
    if (!seeAllBtn || !panel) return;

    const count = parseInt(panel.dataset.count || 0);
    const url = panel.dataset.url || '#';

    if (count > 4) {
      seeAllBtn.style.display = 'inline-block';
      seeAllBtn.href = url;
    } else {
      seeAllBtn.style.display = 'none';
    }
  }

  // initial state
  updateButton(wrapper.querySelector('.group-panel.active'));

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {

      const target = tab.dataset.tab;

      tabs.forEach(t => t.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      tab.classList.add('active');

      const activePanel = wrapper.querySelector(`.group-panel[data-panel="${target}"]`);

      if (activePanel) {
        activePanel.classList.add('active');

        updateButton(activePanel);

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 50);
      }

    });
  });

});